import { postData } from './session';

export async function getTasks(meta = {}, payload = {}) {
    return await postData('com.rnis.kurs.action.portal.task.list', meta, { payload: payload})
}

export async function getTasksGuests(meta = {}, payload = {}, token = null) {
    return await postData('com.rnis.kurs.action.task.list', meta, { payload: payload}, token)
}

export async function getGeometryFromContract(meta = {}, payload = {}, token = null) {
    return await postData('com.rnis.kurs.action.analytics.geometry_form_contract.list', meta, { payload: payload}, token)
}




// WEBPACK FOOTER //
// ./src/helpers/api/kurs.js